export const huifuList = ['huifucard','huifualipay','huifuwechat','huifu']
export const jinglingList = ['jinglingpay']